import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfUserstarIconProps extends SvgIconProps {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfAcdIcon />
 * @returns SVG of align center Icon
 */
export function CcfUserstarIcon(props: CcfUserstarIconProps) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_579_12561)">
        <path
          d="M11 15.6L9.95238 13.4L8.90476 15.6L6.52381 15.9L8.2381 17.6L7.85714 20L9.95238 18.9L12.0476 20L11.6667 17.6L13.381 15.9L11 15.6Z"
          fill="#3F5C69"
        />
        <path
          d="M17.0952 13.2C16.4286 12.3 15.5714 11.6 14.619 11C14.8095 10.7 15.0952 10.4 15.2857 10.1C15.9524 9 16.2381 7.8 16.2381 6.6C16.2381 4.9 15.5714 3.2 14.4286 2C13.1905 0.7 11.5714 0 9.7619 0C8.04762 0.1 6.42857 0.8 5.19048 2.2C4.04762 3.4 3.47619 5 3.47619 6.8C3.47619 8 3.85714 9.2 4.52381 10.3C4.71429 10.6 4.90476 10.9 5.19048 11.2C4.33333 11.8 3.47619 12.5 2.80952 13.4C1.66667 14.9 1 16.7 1 18.2C1 19.1 1.85714 19.9 2.80952 19.9H5.7619V17.9H2.71429C2.80952 16.9 3.57143 15.7 4.33333 14.6C4.90476 13.9 5.57143 13.3 6.23809 12.8L8.04762 11.6L6.52381 9.8C6.33333 9.6 6.23809 9.4 6.04762 9.2C5.66667 8.5 5.38095 7.6 5.38095 6.7C5.38095 5.5 5.85714 4.3 6.61905 3.4C7.47619 2.5 8.61905 2 9.85714 2C11.0952 2 12.2381 2.5 13.0952 3.4C13.9524 4.3 14.3333 5.4 14.4286 6.6C14.4286 7.5 14.2381 8.3 13.7619 9C13.5714 9.2 13.4762 9.5 13.2857 9.7L11.7619 11.5L13.7619 12.7C14.4286 13.1 15.0952 13.7 15.6667 14.4C16.5238 15.4 17 16.7 17.0952 17.7H14.2381V19.7H17.1905C18.1429 19.7 19 18.9 19 18C19 16.5 18.3333 14.7 17.0952 13.2Z"
          fill="#3F5C69"
        />
      </g>
      <defs>
        <clipPath id="clip0_579_12561">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfUserstarIcon;
